import { PropsWithChildren } from 'react';

import ChannelProvider from '@/channels/ChannelProvider';
import { pendingTransactionsChannelName } from '@/channels/utils/channelNames';

import { Props } from './types';

const PendingTransactionsChannel = ({ children, personId }: PropsWithChildren<Props>) => {
  return (
    <ChannelProvider channelName={pendingTransactionsChannelName(personId)}>
      {children}
    </ChannelProvider>
  );
};

export default PendingTransactionsChannel;
